import React, { Fragment, useEffect, useState } from 'react';
import TextInputModuleItem from './TextInputModuleItem';
import { translate } from "../../../Services/translation";
import { useDispatch, useSelector} from 'react-redux';
import { UpdateConfiguratorValue } from '../../../Actions/Configurator/Configurator.action';
import { ConfiguratorConstants } from '../../../Models/Configurator/ConfiguratorConstants';
import { getPropertyTranslation } from '../../../Services/Configurator/ConfiguratorService';

const TextInputModule = (props) => {
    const [opened, setopened] = useState([]);
    const [reload, setreload] = useState(false);   
    const [inputValues, setinputValues] = useState([]);
    const [validations, setvalidations] = useState([]);
    const dispatch = useDispatch();  
    const { configuratorValues, configuratorValuesShareData } = useSelector((state) => state.productConfigurator.payload);
    const [maxHeight, setmaxHeight] = useState(0);
    const [counterForNextRow, setcounterForNextRow] = useState(0);

    useEffect(() => {
        if (configuratorValues) {
            const item = configuratorValues.find(x => x.name === ConfiguratorConstants.MaxHeight);
            if (item) {
                setmaxHeight(item.value);
            }
        }
    }, [configuratorValues]);


    useEffect(() => {
        if (configuratorValuesShareData && configuratorValuesShareData.length > 0) {
            configuratorValuesShareData.map(itemData => {
                if (itemData.name === ConfiguratorConstants.TextInputModuleSectionsProperty) {
                    const modelData = JSON.parse(itemData.value);
                    let tempOpened = [];
                    modelData.map((x) => {
                        tempOpened.push(x.index);
                    });
                    setopened(tempOpened);
                    setinputValues(modelData);
                }
            })                                                
        }
    }, [configuratorValuesShareData]);

    const openedStraightSections = (moduleSectionIndex, add = false) => {
        if (add) {
            let tempOpened = opened;
            if (moduleSectionIndex - 1 !== -1 && tempOpened.indexOf(moduleSectionIndex - 1) === -1) {
                tempOpened.push(moduleSectionIndex - 1);
            } else {
                tempOpened.push(moduleSectionIndex);
            }            
            setopened(tempOpened);
            setreload(!reload);
            setcounterForNextRow(inputValues.length + 1);
        } else {
            let tempOpened = opened;
            tempOpened.splice(tempOpened.indexOf(moduleSectionIndex));
            setopened(tempOpened);
            setreload(!reload);
            setcounterForNextRow(inputValues.length - 1); 
        }
    }
    
    const validate = () => {
        let tempValidations = [];
        inputValues.map(x => {
            const indexValue = x.index;
            if (parseFloat(x.length) <= 0 || parseFloat(x.height) <= 0) {                
                tempValidations.push({indexValue, message: translate("sectionDetailsValidation")});
            }

            if (parseFloat(x.height) > maxHeight) {
                tempValidations.push({indexValue, message: translate("heightValidation").replace("{height}", maxHeight.toString().replace(".", ","))});
            }
        });
        setvalidations(tempValidations);        
        if (tempValidations.length > 0) {
            setreload(!reload);
            return false;
        }
        return true;
    }

    const setStateAndCalculate = () => {
        if (validate()) {            
            dispatch(UpdateConfiguratorValue(ConfiguratorConstants.TextInputModuleSectionsProperty, JSON.stringify(inputValues), true));        
        }   
    }
    

    const onInputChange = (index, length, height) => {
        var tempInputValues = inputValues;
        const lengthTemp = length != 0 ? parseFloat(length.replace(",",".")) : length;
        const heightTemp = height != 0 ? parseFloat(height.replace(",",".")) : height;
        if (tempInputValues.find(x => x.index === index)) {
            let currentValue = tempInputValues.find(x => x.index === index);
            if (length === "" || lengthTemp === NaN) {
                currentValue.length = 0;
            }

            if (lengthTemp > 0) {
                currentValue.length = lengthTemp;
            }

            if (height === "" || heightTemp === NaN) {
                currentValue.height = 0;
            }
            if (heightTemp > 0) {
                currentValue.height = heightTemp;
            }
            tempInputValues.splice(tempInputValues.findIndex(x => x.index === index), 1);
            tempInputValues.push(currentValue);
        } else {
            tempInputValues.push({index, length: lengthTemp, height: heightTemp});
        }        
        setinputValues(tempInputValues);        
    }

    const removeItem = (index) => {
        var tempInputValues = inputValues;
        if (tempInputValues.find(x => x.index === index)) {
            tempInputValues.splice(tempInputValues.findIndex(x => x.index === index), tempInputValues.length - 1);
        }
        setinputValues(tempInputValues);        
    }
    
    return (<Fragment>
        <div className='configurator__calculation-module'>
            <div className='content-wrapper'>
                <h3 className='title'>{props.moduleInfo.title.replace("{walltype}", getPropertyTranslation())}</h3>
                <div className="text"
                    dangerouslySetInnerHTML={{
                        __html: props.moduleInfo.text,
                    }} 
                ></div>
                <div className='configurator__item-container'>
                    {Array(counterForNextRow > 0 ? (parseInt(counterForNextRow / 4) + 1) * 4 : 4).fill(true).map((item, index) => {
                        return (
                            <>                        
                                <TextInputModuleItem key={`${reload}${index}`} onShow={openedStraightSections}
                                    moduleSectionIndex={index} showInput={opened.indexOf(index) > -1} openedItems={opened}
                                    onInputChange={onInputChange} inputValues={inputValues} removeItem={removeItem} 
                                    validations={validations} maxHeight={maxHeight}></TextInputModuleItem>
                            </>)
                    })}
                </div>
                <div className='button-wrapper'>
                    <a onClick={() => setStateAndCalculate() }>{translate("seeCalculations")}</a>
                </div>
            </div>
        </div>
    </Fragment>)
}

export default TextInputModule;